import { GlobalMenu, DeleteDialog } from '@components';

import { useToast } from '@hooks';

import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';

import { useState as useHookState } from '@hookstate/core';

import { NavigationContext } from '@layout/navigation/navigation';

import { InviteUserRole } from '@models/Invite.model';

import { ITaskRawQuery } from '@models/Task.model';

import { deleteTask } from '@services/queries/tasks/deleteTask/deleteTask';

import { Container, Dialogs } from './TaskMenu.styles';

interface ITaskMenu {
  task: ITaskRawQuery;
}

const TaskMenu = ({ task }: ITaskMenu) => {
  const { toast } = useToast();

  const { role } = useContext(NavigationContext);

  const queryClient = useQueryClient();

  const openDeleteDialog = useHookState(false);

  const mutationDelete = useMutation(deleteTask, {
    onSuccess: async () => {
      toast.success('Update was deleted successfully');
      openDeleteDialog.set(false);

      queryClient.invalidateQueries(['tasks']);
    },
    onError: () => {
      toast.error('Something got wrong');
    },
  });

  const options = () => {
    const initialOptions = [
      {
        disabled: ![InviteUserRole.ADMIN].includes(role),
        disableToolTip: [InviteUserRole.ADMIN].includes(role),
        toolTipText: 'Only admins can delete a task.',
        toolTipId: 'deleteTooltip',
        label: 'Delete Task',
        iconName: 'trash',
        onClick: () => {
          openDeleteDialog.set(true);
        },
        bottomSeparator: false,
      },
    ];

    return initialOptions;
  };

  return (
    <Container>
      <GlobalMenu
        align="end"
        hoverColor="#E6E8F0"
        title="Quick Actions"
        itemList={options()}
      />

      <Dialogs
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <DeleteDialog
          open={openDeleteDialog}
          onDelete={() => {
            mutationDelete.mutate({ taskId: task.id });
          }}
        />
      </Dialogs>
    </Container>
  );
};

export { TaskMenu };
